import { Alert, Button, Space } from "antd";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { sports } from "~config/sports";
import { useGenerateReport } from "~pages/Reports/hooks/useGenerateReport.ts";

const SeasonReportsPage = () => {
  const { sport, organizationId, seasonId } = useParams();
  const { formatMessage } = useIntl();
  const { mutate: generateReport } = useGenerateReport();

  return useMemo(() => {
    switch (sport) {
      case sports.BASKETBALL: {
        const onGenerateSeasonEntitiesStatisticReport = () =>
          generateReport({
            url: `${sport}/o/${organizationId}/reports/entities/statistic/in/season/${seasonId}`,
            notificationMessage: formatMessage({ id: "reports.seasonEntitiesStatistic.started" }),
          });

        const onGenerateSeasonPersonsStatisticReport = () =>
          generateReport({
            url: `${sport}/o/${organizationId}/reports/persons/statistic/in/season/${seasonId}`,
            notificationMessage: formatMessage({ id: "reports.seasonPersonsStatistic.started" }),
          });

        const onGenerateSeasonLeadersStatisticReport = () =>
          generateReport({
            url: `${sport}/o/${organizationId}/reports/leaders/statistic/in/season/${seasonId}`,
            notificationMessage: formatMessage({ id: "reports.seasonLeadersStatistic.started" }),
          });

        return (
          <Space>
            <Button onClick={onGenerateSeasonEntitiesStatisticReport} className={"text-uppercase"} size={"large"}>
              {formatMessage({ id: "reports.seasonEntitiesStatistic" })}
            </Button>
            <Button onClick={onGenerateSeasonPersonsStatisticReport} className={"text-uppercase"} size={"large"}>
              {formatMessage({ id: "reports.seasonPersonsStatistic" })}
            </Button>
            <Button onClick={onGenerateSeasonLeadersStatisticReport} className={"text-uppercase"} size={"large"}>
              {formatMessage({ id: "reports.seasonLeadersStatistic" })}
            </Button>
          </Space>
        );
      }
      case sports.HOCKEY:
      case sports.HANDBALL: {
        const onGenerateSeasonEntitiesReport = () =>
          generateReport({
            url: `${sport}/o/${organizationId}/reports/entities/in/season/${seasonId}`,
            notificationMessage: formatMessage({ id: "reports.seasonEntities.started" }),
          });

        const onGenerateSeasonCardsReport = () =>
          generateReport({
            url: `${sport}/o/${organizationId}/reports/cards/in/season/${seasonId}`,
            notificationMessage: formatMessage({ id: "reports.seasonCards.started" }),
          });

        const onGenerateSeasonAppointmentsReport = () =>
          generateReport({
            url: `${sport}/o/${organizationId}/reports/appointments/in/season/${seasonId}`,
            notificationMessage: formatMessage({ id: "reports.seasonAppointments.started" }),
          });

        return (
          <Space>
            <Button onClick={onGenerateSeasonEntitiesReport} className={"text-uppercase"} size={"large"}>
              {formatMessage({ id: "reports.seasonEntities" })}
            </Button>
            <Button onClick={onGenerateSeasonCardsReport} className={"text-uppercase"} size={"large"}>
              {formatMessage({ id: "reports.seasonCards" })}
            </Button>
            <Button onClick={onGenerateSeasonAppointmentsReport} className={"text-uppercase"} size={"large"}>
              {formatMessage({ id: "reports.seasonAppointments" })}
            </Button>
          </Space>
        );
      }
      default:
        return <Alert style={{ width: "max-content" }} message={formatMessage({ id: "reports.notSupported" })} type="warning" showIcon />;
    }
  }, [sport, organizationId, seasonId, generateReport, formatMessage]);
};

export default SeasonReportsPage;
